/**
 *
 * ReportVersion
 *
 */

import { memo } from 'react';

import { Route, Routes } from 'react-router-dom';

import CreateReportVersionStatement from './Create';
import EditReportVersion from './Edit';

interface Props {}

// eslint-disable-next-line react/display-name
export const ReportVersion = memo((props: Props) => {
  return (
    <>
      <Routes>
        <Route path=":reportId/create" element={<CreateReportVersionStatement />} />
        <Route path=":idVersion/:tab" element={<EditReportVersion />} />
      </Routes>
    </>
  );
});
